import { render, staticRenderFns } from "./MoveObject.vue?vue&type=template&id=7f58ec10&scoped=true"
import script from "./MoveObject.vue?vue&type=script&lang=js"
export * from "./MoveObject.vue?vue&type=script&lang=js"
import style0 from "./MoveObject.vue?vue&type=style&index=0&id=7f58ec10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f58ec10",
  null
  
)

export default component.exports